import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "@mui/icons-material";
//
import { Chat, Email, LocationCity, Person, Phone, SafetyCheck, Work } from "@mui/icons-material";

const handleSubmit = () => {

}

function Contact() {
  return (
    <section className="contact">
      <div className="container row">
        <section className=" left-panel ">
          <div className=" contact-container">
            <div
              className="contact-form-wrap shadow pb-3"
            >
              <h2 className="section-subtitle text-primary mt-3">Contact our Sales Team</h2>

              <p className="mt-1 sec-text pl-3 pr-3">
                Send us mail anytime you have any questions and our team will get
                back to you soon.
              </p>
              <form
                onSubmit={handleSubmit}
                // Send DATA to our backend
                action="https://backend"
                method="POST"
                className="contact-form form-inline"
              >
                <div className="row center ">
                  {/* form-content-wrapper */}
                  <div className="form-group col-md-6 mt-4">
                    <input
                      type="text"
                      className="form-control "
                      name="name"
                      id="name"
                      placeholder="First Name"
                      required
                    />
                    <span className="icons">
                      <Person />
                    </span>
                  </div>
                  <div className="form-group col-md-6 mt-4">
                    <input
                      type="text"
                      className="form-control"
                      name="second-name"
                      id="second-name"
                      placeholder="Second Name"
                      required
                    />
                    <span className="icons">
                      <Person />
                    </span>
                  </div>
                  <div className="form-group col-md-6 mt-4">
                    <input
                      type="text"
                      className="form-control "
                      name="rank"
                      id="rank"
                      placeholder="Your Job Title"
                      required
                    />
                    <span className="icons">
                      <SafetyCheck />
                    </span>
                  </div>
                  <div className="form-group col-md-6 mt-4">
                    <input
                      type="text"
                      className="form-control "
                      name="company-name"
                      id="rank"
                      placeholder="Company Name"
                      required
                    />
                    <span className="icons">
                      <Work />
                    </span>
                  </div>
                  <div className="form-group col-md-6 mt-4">
                    <input
                      type="text"
                      className="form-control "
                      name="Country"
                      id="rank"
                      placeholder="Country"
                      required
                    />
                    <span className="icons">
                      <LocationCity />
                    </span>
                  </div>
                  <div className="form-group col-md-6  mt-4">
                    <input
                      type="email"
                      className="form-control "
                      name="email"
                      id="email"
                      placeholder="Work Email Address"
                      required
                    />
                    <span className="icons">
                      <Email />
                    </span>
                  </div>
                  <div className="form-group col-md-6 mt-4">
                    <select
                      name="company-size"
                      id="company-size"
                      className="form-select "
                      required
                    >
                      <option
                        value="Please Select"
                        // disabled="disabled"
                        selected="selected"

                      >
                        - Company Size -
                      </option>
                      <option value="1-10">
                        1-10
                      </option>
                      <option value="11-29">
                        11-29
                      </option>

                      <option value="30-99">30-99</option>
                      <option value="100+">100+</option>
                    </select>
                    {/* <span className="icon-arrow-down"></span> */}
                  </div>
                  <div className="form-group col-md-6 mt-4">
                    <input
                      type="tel"
                      className="form-control "
                      name="number"
                      id="number"
                      placeholder="Phone Number"
                    />
                    <span
                      className="icons"
                    >
                      <Phone />
                    </span>
                  </div>
                  <div className="form-group col-12 mt-4">
                    <textarea
                      name="message"
                      cols="30"
                      rows="6"
                      className="form-control sales-contact"
                      placeholder="Tells how we can help..."
                      required
                    ></textarea>
                    <span className="icons">
                      <Chat />
                    </span>
                  </div>
                  <div className="form-btn col-12 mt-4">
                    <button
                      type="submit"

                      className="btn contact-btn "
                    >
                      Send Message<span className=" ml-4">

                      </span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
        <section className="right-panel pl-5">
          <section>
            <div className=" mb-3">
              <div className="speciality-highlight ">
                <p className="section-subtitle">Why Choose Us?</p>

                <h2 className="h2 center section-title">
                  Here is why we are different from the others:
                </h2>

                <p className="speciality-text">
                  Whether you're starting out or scalling up, grow faster with <strong>DEEPBLUE</strong>. Take a look at some of the best benefits that you will get.
                </p>
                <div className="speciality-content">
                  <ul className="speciality-list column">
                    <li className="speciality-item">
                      <div className="speciality-item-icon">
                        <ChevronRight />
                      </div>
                      <p className="speciality-item-text"> Automate your sales, marketing, and service in one platform. Avoid data leakes and enable consistent messaging.
                      </p>
                    </li>
                    <li className="speciality-item">
                      <div className="speciality-item-icon">
                        <ChevronRight />
                      </div>
                      <p className="speciality-item-text">
                        Market like the most successful companies in the world with Agile CRMS's marketing automation software.
                      </p>
                    </li>
                    <li className="speciality-item">
                      <div className="speciality-item-icon">
                        <ChevronRight />
                      </div>
                      <p className="speciality-item-text">
                        Great customer support seperates decent companies from excellent companies. A positive customer support experience is a crucially important piece of the customer journey.
                      </p>
                    </li>

                  </ul>

                  <p className="callout mt-6">
                    "With <strong>DEEPBLUE</strong>, I have noticed my sales have skyrocket withing weeks of usage. I am glad to make the right choice for selecting <strong>DEEPBLUE</strong>." - <strong>Yakubu Lute, C.E.O - Rentor</strong>"
                  </p>

                  <Link to="/auth" className="btn center">
                    Try for free
                  </Link>
                </div>
              </div>
            </div>


          </section>
        </section>
      </div>

    </section>
  );
}

export default Contact;
